module.exports = __webpack_public_path__ + "img/pdf-300x300.1e67dd5b.png";